<template>
  <b-container fluid id="app">
    <b-container fluid class="header"> 
      <b-container>
        <img alt="Payvend Logo" src="./assets/payvend.png" height="auto" width="100">
      </b-container> 
    </b-container>
    <Content/>
  </b-container>
</template>

<script>
import Content from './components/Content.vue'

export default {
  name: 'App',
  components: {
    Content
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  background-color: lightgrey;
  padding-right: 0px;
  padding-left: 0px;
}
.row{
  padding: 0 0 0 0;
}
.col{
  padding: 0 0 0 0;
}
.header{
  background-color: white;
  margin-bottom: 10px;
}
</style>
